<template>
	<div class="wrapper">
		<sub-ibox-title :is-show-back=true>
			<p slot="title">{{params.id ? '编辑' : '新增'}}轮播</p>
		</sub-ibox-title>
		<section class="content">
			<div class="detail-cont">
				<div class="fx fx-y-center m-t-15">
					<div class="title fx w120 m-r-5"><p class="ask-cont"><i class="ask">*</i></p><span class="fx-fill">轮播图 </span></div>
					<!--<z-up-file :listArr="picList"></z-up-file>-->
					<z-upload :file-url='params.pic' :on-success="handleUploadSuccess"></z-upload>
					<!--<div>
						<div v-if="params.pic" class="question-api">
							<input @change="handleFile" id="file" type="file" name="file" multiple>
							<img v-if="params.pic" :src="params.pic" />
							<div class="edit fx-align"><span class="icon icon-edit"></span></div>
						</div>
						<div class="file-btn" v-show="!params.pic">
							<input @change="handleFile" id="files" type="file" name="file" multiple>
							<a class="z-btn z-btn-primary b-r-3">上传</a>
						</div>
					</div>-->
					<div class="pic-tips m-l-10">建议尺寸：640*300；文件大小建议300KB以内</div>
				</div>
				<z-input title="点击跳转链接" class="m-t-15" v-model="params.url" placeholder="地址请带上http://或者https://"></z-input>
			</div>
			<div class="m-t-30 fx">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleSave">保存</a>
			</div>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	let contentEditor = null;
	export default {
		name: 'ClassifyEdit',
		components: {},
		data() {
			return {
				params: {
					id: null,
					pic: '',
					url: ''
				}
			}
		},
		mounted() {
			this.params.id = this.$route.query.id || null
			if(this.$re_Number(this.params.id)) this.handleGetBannerInfo();
			
		},
		methods: {
			//图片上传成功回调
			handleUploadSuccess(url){
				this.params.pic = url
			},
			//保存
			handleSave() {
				if(!this.params.pic) return this.$warning('请上传图片');
				if(this.params.url && !this.$re_Isurl(this.params.url)) return this.$warning('请输入合法的跳转链接地址');

				this.saveBanner(this.params).then(() => {
					this.$success('保存成功');
					this.$back();
				}, (error) => {
					this.$errorMsg(error)
				})
			},

			//获取轮播详情
			handleGetBannerInfo() {
				this.getBannerInfo({
					id:this.params.id
				}).then((data) => {
					this.params.pic = data.pic;
					this.params.url = data.url;
				}, () => {
					this.$errorMsg('获取数据失败/(ㄒoㄒ)/~~')
				})
			},
			...mapActions(['getBannerInfo', 'saveBanner']),
		}
	}
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	#content {
		min-height: px-em(400px);
	}
	.content{
		border-top: none;
	}
	.detail-cont {
		width: 600px;
		.question-api {
			position: relative;
			width: px-em(120px);
			height: px-em(120px);
			border: 1px solid $color-border;
			overflow: hidden;
			&:hover {
				.edit {
					opacity: 1;
				}
			}
			input {
				display: inline-block;
				width: px-em(120px);
				height: px-em(120px);
				opacity: 0;
				position: relative;
				z-index: 99;
				cursor: pointer;
			}
			img {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
			}
			.edit {
				opacity: 0;
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.3);
				transition: all 0.2s ease;
				.icon {
					transition: all 0.2s ease;
					color: #fff;
					font-size: px-em(32px);
				}
			}
		}
		.tips-sort {
			padding-left: px-em(170px);
			padding-top: px-em(10px);
			color: $color-gray;
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.wrapper{
			min-width: px-em(1000px);
			.detail-cont{
				width: px-em(900px);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// BannerEdit.vue?61e33fef